<template>
	<tr>
        <td width="20%">
            <img v-if="video.picture_id" class="img-rounded img-responsive" :src="'https://i.vimeocdn.com/video/' + video.picture_id + '-' + video.picture_key +'-d_300x180'">
            <img v-else class="img-rounded img-responsive" src="../../assets/vimeo_thumbnail_default.jpg"></td>
        <td>
            <h5 class="margin-bottom-5">{{video.title}}</h5>
            <span v-if="video.state === VIDEO_STATE.READY" :class="getClassLabelVisibilityVideo(video.visibility)" class="label">{{getStringVisibilityVideo(video.visibility)}}</span>
            <span v-else class="label label-default">{{getStringStateVideo(video.state)}}</span>
        </td>
        <td class="hidden-xs">{{getDurationTime(video.duration)}}</td>
        <td>{{getDataExtendString(video.created_date)}}</td>
        <td class="text-right">
            <router-link  class="btn btn-default" :to="{ name: 'video_detail', params: { video_id: video.id }}">
                <i class="las la-edit"></i>{{ $t('common.edit') }}
            </router-link>
        </td>
	</tr>
</template>

<script>

import {VIDEO_STATE} from "../../common/constants";
import {Utils} from "../../common/utils";

export default {
	name: "VideoRow",
	props: {
		video: {
			type: Object,
			require: true
		}
	},
    data: () => {
        return {
            VIDEO_STATE: VIDEO_STATE
        }
    },
    methods: {
        getDataExtendString(date){
            return Utils.getDateStringFromISO(date)
        },
        getDurationTime(seconds) {
            return Utils.getDurationTime(seconds)
        },
        getClassLabelVisibilityVideo(visibility) {
            return Utils.getClassLabelVisibilityVideo(visibility)
        },
        getStringVisibilityVideo(visibility) {
            return Utils.getStringVisibilityVideo(visibility)
        },
        getStringStateVideo(state) {
            return Utils.getStringStateVideo(state)
        }
    }
};
</script>
